<template>
  <div class="d-flex justify-center align-center fill-height">
    <v-form v-model="valid" @submit.prevent="handleSubmit" ref="loginForm" autocomplete="off">
      <v-container class="pt-0 pb-0">
        <v-row justify="center">
          <v-col cols="12" class="text-center mb-3">
            <v-img :src="imagePath('logo')" width="180" class="mr-auto ml-auto"></v-img>
          </v-col>
          <v-col cols="10" sm="12" md="8" lg="9">
            <v-text-field
                    solo
                    :label="'نام کاربری'"
                    append-icon="mdi-account"
                    :rules="rules.username"
                    v-model="username"
            ></v-text-field>
            <v-text-field
                    type="password"
                    solo
                    :label="'رمز عبور'"
                    append-icon="mdi-lock"
                    :rules="rules.password"
                    v-model="password"
            ></v-text-field>

<!--            <v-row class="pb-3">-->
<!--              <v-col cols="12">-->
<!--                <v-text-field-->
<!--                        type="number"-->
<!--                        solo-->
<!--                        :label="'کد تصویر...'"-->
<!--                        append-icon="mdi-image"-->
<!--                        v-model="captcha"-->
<!--                        hide-details-->
<!--                ></v-text-field>-->
<!--              </v-col>-->
<!--              <v-col cols="3" class="d-flex justify-end align-center">-->
<!--                <v-icon large color="primary" @click="updateCaptcha()">mdi-refresh</v-icon>-->
<!--              </v-col>-->
<!--              <v-col cols="9" class="d-flex justify-center align-center" >-->
<!--                <v-img v-show="captchaLoaded"-->
<!--                       class="rounded"-->
<!--                       ref="captcha"-->
<!--                       :src="captchaSrc"-->
<!--                       @load="captchaLoaded = true"-->
<!--                       :max-height="40"-->
<!--                       contain-->
<!--                ></v-img>-->
<!--                <v-progress-circular v-if="!captchaLoaded" :size="30" indeterminate color="gray"></v-progress-circular>-->
<!--              </v-col>-->

<!--            </v-row>-->


            <v-btn type="submit" color="primary" class="mb-3" large block :loading="loading" :disabled="!valid">
              ورود به حساب کاربری
            </v-btn>
            <v-btn to="/user/register" replace color="secondary" large block>
              ثبت نام در آموزشگاه آنلاین عکاسی
            </v-btn>

            <v-btn
                    text
                    color="primary"
                    @click="goToPasswordResetLink"
                    large block
            >
              رمز عبور را فراموش کرده ام!
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
  </div>
</template>
<script>
    import {mapGetters, mapActions} from 'vuex'

    export default {
        name: 'userLogin',
        data: function () {
            return {
                username: '',
                password: '',
                rules: {
                    username: [],
                    password: [],
                },
                valid: false,
                loading: false,
                checked: false,
                // captcha: '',
                // captchaLoaded: false,
                // captchaSrc: null,
            };
        },
        computed: {
            ...mapGetters(['authenticated']),
        },
        methods: {
            ...mapActions('user', ['login']),
            handleSubmit() {
                const self = this;
                self.rules = self.formRules();
                setTimeout(async function () {
                    if (self.$refs.loginForm.validate()) {
                        self.loading = true;
                        const response = await self.login({
                            username: self.username,
                            password: self.password,
                            captcha: self.captcha,
                        });
                        console.log(response);
                        if (response) {
                            await self.$router.replace('/');
                        }


                        self.loading = false;
                    }
                });
            },
            formRules() {

                return {
                    username: [(v) => v.length >= 4 || 'نام کاربری کمتر از 4 کاراکتر است.'],
                    password: [(v) => v.length >= 6 || 'رمز عبور کمتر از 6 کاراکتر است.'],
                };
            },
            goToPasswordResetLink(){
                window.open('https://shootshot.com/my-account/lost-password/','_blank');
            },
            // captchaUrl(){
            //     const now = Date.now();
            //     return 'http://game.shootshot.com/captcha2/captcha2.php?' + now;
            // },
            // updateCaptcha(){
            //     this.captchaLoaded = false;
            //     this.captchaSrc = this.captchaUrl();
            // }
        },
        async created() {
            if (this.authenticated)
                await this.$router.push('/');
        },
        // mounted() {
        //     this.captchaSrc = this.captchaUrl();
        // }
    }
</script>